<template>
    <div>
        <template v-if="!geral">

            <az-break-title title="Contrato" />

            <div>

                <div class="row mb-3">
                    <div class="col col-12 col-md-6">
                        <az-input icon="fas fa-search" v-model="search" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-success" @click="incluir ()">
                            Incluir Contrato
                        </button>
                    </div>
                </div>

            </div>

            <div v-if="!lista || !lista.length">
                <az-empty-state icon="fas fa-search" msg="Nenhuma operadora identificada."
                    :action="!search ? 'Incluir Operadora' : ''" :method="incluir" />
            </div>

            <div v-if="lista && lista.length">

                <ordenacao-dragn-drop v-model="pode_ordenar" :search="search" />

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary"
                        :draggable="search || !pode_ordenar ? '.none' : '.list-group-item'">
                        <li class="list-group-item d-flex justify-content-between"
                            v-for="(dado, id) in lista" :key="id">
                            <span>
                                <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                    {{ dado.search }}
                                </a>

                                <span class="badge badge-secondary mr-3">#{{ dado.id_contrato_operadora }}</span>

                                <span class="badge badge-danger" v-if="dado.fl_suspenso">Suspenso</span>
                            </span>
                            <span class="d-flex">
                                <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                    <input type="checkbox" class="custom-control-input" :id="'ativo-' + id"
                                        v-model="dado.fl_ativo"
                                        @change="toggle(dado)">
                                    <label class="custom-control-label" :for="'ativo-' + id"></label>
                                </div>
                                <div v-else>
                                    <span>
                                        <span class="mr-3" v-if="dado.st_numero_prestador">
                                            {{ dado.st_numero_prestador }}
                                        </span>
                                        <span class="mr-3 mb-0" v-if="dado.fl_ativo && dado.fl_reembolso" title="Reembolso">
                                            <i class="fas fa-dollar-sign text-primary"></i>
                                        </span>
                                        <span class="mr-3" v-if="dado.fl_ativo && !dado.dt_validade">
                                            <i class="fa fa-exclamation-triangle text-secondary" data-toggle="tooltip" data-placement="top" title="Contrato sem data de vencimento."></i>
                                        </span>
                                        <span class="mr-3" v-if="dado.fl_ativo && dado.dt_validade && dado.dt_validade < $util.hoje()">
                                            <i class="fa fa-exclamation-triangle text-danger" data-toggle="tooltip" data-placement="top" title="Contrato vencido."></i>
                                        </span>
                                        <span class="mr-3" v-else-if="dado.fl_ativo && dado.dt_validade && dado.dt_validade < teste_valid">
                                            <i class="fa fa-exclamation-triangle text-warning" data-toggle="tooltip" data-placement="top" title="Contrato perto de vencer."></i>
                                        </span>
                                        <span class="badge badge-secondary mr-3" v-if="dado.filtros && dado.filtros.length" :title="dado.filtros.length + ' filtro(s)'">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            {{ dado.filtros.length }}
                                        </span>
                                        <button type="button" class="btn btn-outline-primary btn-sm" @click="abrir_anexar_arquivo(dado)">
                                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                            {{ dado.arquivos.length }}
                                        </button>

                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="$refs.elo.abrir(dado.link_elo)" v-if="1 ==0 && !setup && dado && dado.link_elo">
                                            ELO
                                        </button>

                                        <a :href="dado.link_elo" target="_blank" type="button" class="btn btn-outline-primary btn-sm ml-1" v-if="!setup && dado && dado.link_elo">
                                            ELO
                                        </a>
                                    </span>
                                </div>
                            </span>
                        </li>
                    </draggable>
                </div>

                <div class="alert alert-secondary" v-if="dados && dados.length == 1 && dados[0].filtros.length">
                    <i class="fa fa-exclamation-triangle mr-3" aria-hidden="true"></i>
                    Contrato com filtros aplicados. Os atendimentos que não se encaixarem nesse filtro ficarão sem contrato identificado.
                </div>

            </div>

        </template>

        <!-- Modal -->
        <div class="modal fade" id="contratoOperadoraModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Contrato:
                            {{ item.id_contrato_operadora ? '#' + item.id_contrato_operadora : '(Novo)' }}
                            <span class="badge badge-danger ml-2" v-if="item && item.fl_suspenso">Suspenso</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Número do Contrato"
                                    :validate="validate"
                                    :maxlength="20"
                                    v-model="item.st_numero_contrato" />
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input
                                    sizing="sm"
                                    label="Descrição"
                                    :validate="validate"
                                    :maxlength="100"
                                    v-model="item.st_descricao_arquivo_contrato" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="date"
                                    label="Data do Contrato"
                                    :validate="validate"
                                    v-model="item.dt_contrato" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    type="date"
                                    label="Data da Validade"
                                    :validate="validate"
                                    v-model="item.dt_validade" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tipo de Código"
                                    type="select"
                                    :optionsList="[
                                        { id: '1', search: 'Prestador Operadora' },
                                        { id: '2', search: 'CNPJ como código' },
                                        { id: '3', search: 'CPF como código' },
                                        { id: '4', search: 'CRM como código' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.ch_tipo_codigo_operadora" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Código na Operadora"
                                    :placeholder="item.ch_tipo_codigo_operadora == '2' 
                                        ? 'CNPJ como Código...' : 
                                        (item.ch_tipo_codigo_operadora == '3' ? 'CPF como Código...' : 
                                            (item.ch_tipo_codigo_operadora == '4' ? 'CRM como Código...' : 'Código...'))"
                                    :validate="validate"
                                    :maxlength="20"
                                    :type="item.ch_tipo_codigo_operadora == 2 ? 'cnpj' : (item.ch_tipo_codigo_operadora == 3 ? 'cpf' : 'text')"
                                    v-model="item.st_numero_prestador">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tipo de Código (Autorização)"
                                    type="select"
                                    :optionsList="[
                                        { id: '1', search: 'Prestador Operadora' },
                                        { id: '2', search: 'CNPJ como código' },
                                        { id: '3', search: 'CPF como código' },
                                        { id: '4', search: 'CRM como código' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.ch_tipo_codigo_operadora_autor" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Código na Operadora (Autorização)"
                                    placeholder="O mesmo..."
                                    :validate="validate"
                                    :maxlength="20"
                                    v-model="item.st_numero_prestador_autorizacao">
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-5">
                                <az-input
                                    sizing="sm"
                                    label="Nome do Contratado"
                                    :validate="validate"
                                    :maxlength="255"
                                    v-model="item.st_nome_contratado" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Natureza do Contrato"
                                    type="select"
                                    :optionsList="[
                                        { id: 'J', search: 'Jurídica (cnpj)' },
                                        { id: 'F', search: 'Física (cpf)' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.ch_natureza" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    :type="item.ch_natureza == 'F' ? 'cpf' : 'cnpj'"
                                    :label="item.ch_natureza == 'F' ? 'CPF' : 'CNPJ'"
                                    :validate="validate"
                                    v-model="item.st_cpf_cnpj" />
                            </div>
                            <div class="col col-12 col-md-1">
                                <az-input
                                    sizing="sm"
                                    type="cnes"
                                    label="CNES"
                                    :validate="validate"
                                    :maxlength="7"
                                    v-model="item.st_cnes" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Código Externo"
                                    placeholder="Integração..."
                                    :validate="validate"
                                    v-model="item.st_id_externo" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.tem_cc">
                            <div class="col col-12 col-md-5">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    label="Guia Padrão para Atendimento Externo"
                                    :optionsList="[
                                        { id: 'H', search: 'Honorário Individual' },
                                        { id: 'R', search: 'Resumo de Internação'},
                                        { id: 'S', search: 'SP/SADT' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.ch_externo_tipo_guia" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input 
                                    sizing="sm"
                                    type="money"
                                    label="Valor de Cota de Atendimento"
                                    :validate="validate"
                                    v-model="item.dc_valor_cota" />
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Suspenso"
                                    :validate="validate"
                                    v-model="item.fl_suspenso" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="2"
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Atendimento com Reembolso"
                                    :validate="validate"
                                    v-model="item.fl_reembolso" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    icon="far fa-building fa-fw"
                                    type="select"
                                    placeholder="Nota Fiscal pela Unidade de Atendimento"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    v-model="item.id_unidade_operacao_reembolso_nf">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">NF</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="mt-3" v-if="true">

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Profissional Solicitante"
                                        v-model="item.fl_fixar_solicitante" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_solicitante">
                                    <az-input
                                        sizing="sm"
                                        :key="'medico_sol'"
                                        icon="fas fa-user-md fa-fw"
                                        type="select"
                                        optionsMode="aql"
                                        service="medicos.index"
                                        optionsName="medicos-cadastro-ativos"
                                        optionsData="id_pessoa"
                                        :optionsParm="{ ativos: true }"
                                        v-model="item.id_medico_sol" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Profissional Executante"
                                        v-model="item.fl_fixar_executante" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_executante">
                                    <az-input
                                        sizing="sm"
                                        :key="'medico_exec'"
                                        icon="fas fa-user-md fa-fw"
                                        type="select"
                                        optionsMode="aql"
                                        service="medicos.index"
                                        optionsName="medicos-cadastro-ativos"
                                        optionsData="id_pessoa"
                                        :optionsParm="{ ativos: true }"
                                        v-model="item.id_medico_exe" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar CBOS Executante"
                                        v-model="item.fl_fixar_cbos_executante" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_cbos_executante">
                                    <az-input
                                        sizing="sm"
                                        :key="'medico_exec_cbos'"
                                        v-model="item.st_cbos_executante" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Usar Profissional Solicitante como Contratado Solicitante"
                                        v-model="item.fl_contratado_solic_profissional" />
                                </div>
                                <!-- Este campo não será usado no momento. Esperando necessidades futuras. -->
                                <div class="col col-12 col-md-2" v-if="1 == 0 && item.fl_contratado_solic_profissional">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Tipo de Código"
                                        type="select"
                                        :optionsList="[
                                            { id: '1', search: 'Prestador Operadora' },
                                            { id: '2', search: 'CNPJ como código' },
                                            { id: '3', search: 'CPF como código' },
                                        ]"
                                        optionsData="id"
                                        v-model="item.ch_contratado_solic_profissional" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_contratado_solic_profissional">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Código do contratado solicitante"
                                        :validate="validate"
                                        v-model="item.st_contratado_solic_profissional" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Tipo de Atendimento"
                                        v-model="item.fl_fixar_tipo_atendimento" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_tipo_atendimento">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo-atend'"
                                        icon="fab fa-tumblr fa-fw"
                                        type="select"
                                        optionsMode="aql"
                                        service="tipo_atendimentos.index"
                                        optionsData="id_tipo_atendimento"
                                        :optionsParm="{ ativos: true }"
                                        required
                                        :validate="validate"
                                        v-model="item.id_tipo_atendimento" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Regime de Atendimento"
                                        v-model="item.fl_fixar_regime_atendimento" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_regime_atendimento">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo-atend'"
                                        icon="fab fa-tumblr fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: '01', search: 'Ambulatorial' },
                                            { id: '02', search: 'Domiciliar' },
                                            { id: '03', search: 'Internação' },
                                            { id: '04', search: 'Pronto Socorro' },
                                            { id: '05', search: 'Telessaúde' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="item.st_regime_atendimento" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Regime de Internação (Guia Resumo Internação)"
                                        v-model="item.fl_fixar_regime_internacao" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_regime_internacao">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo-atend'"
                                        icon="fab fa-tumblr fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: '1', search: 'Hospitalar' }, 
                                            { id: '2', search: 'Hospital-Dia' }, 
                                            { id: '3', search: 'Domiciliar' }, 
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="item.st_regime_internacao" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Saúde Ocupacional"
                                        v-model="item.fl_fixar_saude_ocupacional" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_saude_ocupacional">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo-atend'"
                                        icon="fab fa-tumblr fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: '01', search: 'Admissional' },
                                            { id: '02', search: 'Demissional' },
                                            { id: '03', search: 'Periódico' },
                                            { id: '04', search: 'Retorno ao trabalho' },
                                            { id: '05', search: 'Mudança de função' },
                                            { id: '05', search: 'Promoção a saúde' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="item.st_saude_ocupacional" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Tipo de Consulta"
                                        v-model="item.fl_fixar_tipo_consulta" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_tipo_consulta">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo_consulta'"
                                        icon="fas fa-briefcase-medical fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: 1, search: 'Primeira Consulta' },
                                            { id: 2, search: 'Retorno' },
                                            { id: 3, search: 'Pré-Natal' },
                                            { id: 4, search: 'Encaminhamento' },
                                        ]"
                                        optionsData="id"
                                        v-model="item.in_tipo_consulta" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Carater de Atendimento"
                                        v-model="item.fl_fixar_carater" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_carater">
                                    <az-input
                                        sizing="sm"
                                        :key="'careter'"
                                        icon="far fa-copyright fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: 'E', search: 'Eletivo' },
                                            { id: 'U', search: 'Urgência' },
                                        ]"
                                        optionsData="id"
                                        v-model="item.ch_carater" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar indicação de acidente"
                                        v-model="item.fl_fixar_indicacao_acidente" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_indicacao_acidente">
                                    <az-input
                                        sizing="sm"
                                        :key="'careter'"
                                        icon="far fa-copyright fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: '0', search: 'Acidente de trabalho ou doença relacionada ao trabalho' },
                                            { id: '1', search: 'Acidente de trânsito' },
                                            { id: '2', search: 'Outros acientes' },
                                            { id: '9', search: 'Nenhum' }
                                        ]"
                                        optionsData="id"
                                        v-model="item.in_indicacao_acidente" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Tipo de Faturamento na Guia de Resumo de Internação"
                                        v-model="item.fl_fixar_ri_tipo_fat" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_ri_tipo_fat">
                                    <az-input
                                        sizing="sm"
                                        :key="'tipo_fat'"
                                        icon="fa-solid fa-t fa-fw"
                                        type="select"
                                        :optionsList="[
                                            { id: '1', search: 'Parcial' },
                                            { id: '2', search: 'Final' },
                                            { id: '3', search: 'Complementar' },
                                            { id: '4', search: 'Total' }
                                        ]"
                                        optionsData="id"
                                        v-model="item.st_ri_tipo_fat" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixar Grau de Participação"
                                        v-model="item.fl_fixar_grau_part" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_fixar_grau_part">
                                    <az-input
                                        sizing="sm"
                                        :key="'grau-part'"
                                        icon="fa-solid fa-user-doctor"
                                        placeholder="Grau (Ex.: 00, 12, etc.). Em branco para omitir o campo..."
                                        :validate="validate"
                                        v-model="item.st_grau_part" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Preencher número atribuido pela operadora com a Senha"
                                        v-model="item.fl_senha_guia_numero_atrib" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Restringir código do conselho profissional dos médicos solicitantes"
                                        v-model="item.fl_restringir_conselho_solic" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="item.fl_restringir_conselho_solic">
                                    <az-input
                                        sizing="sm"
                                        icon="fa-solid fa-user-doctor"
                                        placeholder="Códigos válidos (Ex.: 06, 08, 10)..."
                                        :validate="validate"
                                        v-model="item.st_restringir_conselho_solic_items" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="item.fl_restringir_conselho_solic">
                                    <az-input
                                        sizing="sm"
                                        icon="fa-solid fa-user-doctor"
                                        placeholder="Default (Ex.: 10)..."
                                        :validate="validate"
                                        v-model="item.st_restringir_conselho_solic_default" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Prefixo no código do conselho profissional dos prestadores no arquivo TISS"
                                        v-model="item.fl_prefixo_conselho_prestador" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="item.fl_prefixo_conselho_prestador">
                                    <az-input
                                        sizing="sm"
                                        icon="fa-solid fa-user-doctor"
                                        placeholder="Informe o prefixo do conselho..."
                                        :validate="validate"
                                        v-model="item.st_prefixo_conselho_prestador" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Não enviar Redução/Acrescimo"
                                        v-model="item.fl_nao_enviar_reducao" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Gerar arquivo de fatura só com médicos cooperados"
                                        v-model="item.fl_cooperado_equipe" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Equipe com contrato na operadora pelo CRM"
                                        v-model="item.fl_contratado_executante_crm" />
                                </div>
                            </div>

                        </div>

                        <template v-if="dados && dados.length > 0 && dados[0].operadora && dados[0].operadora.id_areport_oper_service">
                            <az-sub-title title="Credenciais para autorização online" />
                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        v-if="item.js_online_credenciais && item.js_online_credenciais.hasOwnProperty('login')"
                                        sizing="sm"
                                        label="Login"
                                        placeholder="Login..."
                                        :validate="validate"
                                        v-model="item.js_online_credenciais.login">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        v-if="item.js_online_credenciais && item.js_online_credenciais.hasOwnProperty('senha')"
                                        @clickButton="showInfo(item.js_online_credenciais.senha)"
                                        type="password"
                                        sizing="sm"
                                        label="Senha"
                                        placeholder="Senha..."
                                        icon="fas fa-eye"
                                        :buttonIcon="true"
                                        buttonText="fas fa-eye"
                                        :validate="validate"
                                        v-model="item.js_online_credenciais.senha">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        v-if="item.js_online_credenciais && item.js_online_credenciais.hasOwnProperty('api_key')"
                                        @clickButton="showInfo(item.js_online_credenciais.api_key)"
                                        type="password"
                                        sizing="sm"
                                        label="Api Key"
                                        placeholder="Api Key..."
                                        icon="fas fa-eye"
                                        :buttonIcon="true"
                                        buttonText="fas fa-eye"
                                        :validate="validate"
                                        v-model="item.js_online_credenciais.api_key">
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <contrato-fixar-executante
                            v-if="!item.fl_fixar_executante"
                            v-model="item.js_fixar_executante"
                            :validate="validate"
                            :opcoes="lista_opcoes_filtro_fixar"
                            class="mt-3" />

                        <!-- Impostos -->
                        <template v-if="item.impostos">
                            <az-sub-title title="Impostos">
                                <a href="#" class="card-link" @click.prevent="incluir_imposto()">
                                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                    Incluir Imposto
                                </a>
                            </az-sub-title>

                            <div v-if="!item.impostos.length">
                                Nenhum imposto identificado para o contrato.
                            </div>

                            <div v-for="(imposto, iix) in item.impostos" :key="iix">
                                <div class="form-row" v-show="!imposto.excluido">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="impostos.index"
                                            optionsData="id_imposto"
                                            :optionsParm="{ ativos: true, natureza: 'C' }"
                                            required
                                            :validate="validate"
                                            v-model="imposto.id_imposto">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="imposto.excluido = true">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Reter"
                                            v-model="imposto.fl_reter" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            icon="fa-solid fa-percent"
                                            sizing="sm"
                                            type="money"
                                            v-model="imposto.dc_percentual" />
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Filtros -->
                        <filtro-model v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" class="mt-3" />
                        <br><br>

                        <!-- webservices -->
                        <template v-if="item && item.is_overmind">
                            <az-sub-title title="Overmind / URLs" />
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="SOLICITAÇÃO - Webservice para solicitação de Autorização"
                                        v-model="item.js_webservices.solicitacao">
                                    </az-input>
                                </div>
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="STATUS - Webservice para consulta de Status de Autorização"
                                        v-model="item.js_webservices.status">
                                    </az-input>
                                </div>
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="CANCELAMENTO - Webservice para solicitação cancelamento de Autorização"
                                        v-model="item.js_webservices.cancelamento">
                                    </az-input>
                                </div>
                            </div>
                        </template>

                      <az-sub-title title="Endereço"/>
                      <cadastro-endereco sizing="sm" v-model="item.endereco"/>

                        <template v-if="contador_guias_contrato">
                      
                            <az-sub-title title="Contador para Guias" />

                            <div class="row">
                                <div class="col col-6">
                                <az-input
                                    label="Habilitar Contador de Guias para esse Contrato"
                                    sizing="sm"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_contador_guias"
                                />
                                </div>
                            </div>

                            <div class="row" v-if="item.fl_contador_guias">
                                <div class="col col-12 col-md-3">
                                <az-input
                                    label="Inicial"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_inicio_contador_guia"
                                />
                                </div>
                                <div class="col col-12 col-md-3">
                                <az-input
                                    label="Final"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_fim_contador_guia"
                                />
                                </div>
                                <div class="col col-12 col-md-3" v-if="false">
                                <az-input
                                    label="Notificar Próximidade do Término do Contador"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_qtd_guias_fim_contador"
                                />
                                </div>
                                <div class="col col-12 col-md-3">
                                <az-input
                                    label="contador para guia de consulta"
                                    type="checkbox"
                                    :validate="validate"
                                    v-model="item.contador_guia_consulta"
                                />
                                </div>
                            </div>

                            <div v-if="item.fl_contador_guias && item.contador_guia_consulta">
                                <az-sub-title title="Contador para Guia de Consulta" />
                                <div class="row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                    label="Inicial"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_inicio_contador_guia_consulta"
                                    />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                    label="Final"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_fim_contador_guia_consulta"
                                    />
                                </div>
                                <div class="col col-12 col-md-3" v-if="false">
                                    <az-input
                                    label="Notificar Próximidade do Término do Contador"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_qtd_guias_consulta_fim_contador"
                                    />
                                </div>
                                </div>
                            </div>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="contratoOperadora" :id="item.id_contrato_operadora" v-if="item && item.id_contrato_operadora" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="load(false)"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'contratoOperadora', model_id: item.id_contrato_operadora }" />
        </template>

        <!-- Instrução Modal -->
        <div class="modal fade" id="instrucaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Informação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        {{ instrucao }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <client-elo ref="elo" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import FiltroModel from '../../shared/FiltroModel.vue';
import AzFileUpload from '../../../util/AzFileUpload.vue';
import draggable from "vuedraggable";
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import OrdenacaoDragnDrop from '../../shared/OrdenacaoDragnDrop.vue';
import ContratoFixarExecutante from './ContratoFixarExecutante.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import ClientElo from '../../../shared/elo/ClientElo.vue';
import CadastroEndereco from "@/components/shared/CadastroEndereco.vue";

export default {
    data () {
        return {
            dados: null,
            search: "",
            item: null,
            validate: false,
            viewMode: "A",
            acao_anexar: false,
            drag: false,
            teste_valid: moment().add(30, "days").format('YYYY-MM-DD'),
            pode_ordenar: false,
            instrucao: '',
            contador_guias_contrato: false,
        }
    },

    components: {
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        FiltroModel,
        AzFileUpload,
        draggable,
        AzAuditLogButton,
        OrdenacaoDragnDrop,
        ContratoFixarExecutante,
        AzSubTitle,
        ClientElo,
        CadastroEndereco
    },

    props: ['id_operadora', 'geral', 'setup'],

    computed: {
        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ?
                    this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo )
                    .filter (item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    }) : null ;
            },

            set(newLista) {
                if ( this.viewMode == 'A' ) {
                    this.dados = newLista.concat(this.dados.filter(item => !item.fl_ativo ));
                } else {
                    this.dados = newLista;
                }
            }
        },

        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index', model_id: 'id_classe_procedimento'},
                {id:'tag-medico', search:'Classificação do Prestador', service: 'medicos.index', tag: true},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index', model_id: 'id_especialidade'},
                {id:'App\\azure\\procedimentoGrupo', search:'Grupo de Procedimento', service: 'procedimento_grupos.index'}, 
                {id:'App\\azure\\centroCirurgico', search:'Hospital/Centro Cirúrgico', service: 'centro_cirurgicos.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true, model_id: 'id_plano'},
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index', model_id: 'id_procedimento'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index', model_id: 'id_pessoa'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }, model_id: 'id_recepcao'},
                {id:'App\\azure\\grauParticipacao', search:'Grau de Participação', service: 'grau_participacoes.index', model_id: 'id_grau_participacao'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) {
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index', model_id: 'id_unidade_operacao'});
                opcoes.push({id:'tag-unidade', search:'Classificação da Unidade', service: 'unidade_operacaos.index', tag: true});
            }

            return _.orderBy(opcoes, 'search');
        },

        lista_opcoes_filtro_fixar: function () {
            let opcoes = [
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index', model_id: 'id_procedimento'},
            ];

            return _.orderBy(opcoes, 'search');
        },
    },

    methods: {
        incluir_imposto () { 
            this.item.impostos.push({
                id_imposto: "",
                fl_reter: true, 
                dc_percentual: 0, 
                excluido: false, 
            });
        },

        showInfo (texto) {
            this.instrucao = texto;

            $('#instrucaoModal').modal('show');
        },
        atualizarOrdem () {

            this.$util.atualizar(this, {
                service: 'contrato_operadoras',
                func: 'ordem',
                dados: {
                    lista: this.lista
                },
                toast: true,
            });

        },

        abrir_anexar_arquivo(item) {
            this.item = item;
            this.acao_anexar = true;

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        incluir () {

            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 

                this.item = {
                    id_contrato_operadora: null,
                    id_operadora: this.id_operadora,
                    cnpj_como_codigo: true,
                    filtros: [],
                    fl_ativo: true,
                    st_numero_contrato: "",
                    dt_contrato: "",
                    st_numero_prestador: "",
                    st_observacoes: "",
                    in_regra_ordem: 9999,
                    id_unidade_operacao_reembolso_nf: "",
                };

                $('#contratoOperadoraModal').modal('show');

            });

        },

        editar (item) {

            this.validate = false;

            this.item = null; 

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);

                if(!this.item.endereco) {
                  this.item.endereco = {};
                }

              $('#contratoOperadoraModal').modal('show');
            });

        },

        toggle (item) {

            this.$util.toggle(this, {
                service: 'contrato_operadoras',
                dados: item,
            });

        },

        atualizar () {
            console.log(this.item);

            this.$util.atualizar (this, {
                service: 'contrato_operadoras',
                dados: this.item,
                reload: true,
                modal: 'contratoOperadoraModal',
                callback: () => {
                    this.$emit('refresh');
                }
            });

        },

        load() {
            this.$util.load(this, {
                service: 'contrato_operadoras',
                func: 'index',
                configs: ['gerar-numero-guia-por-contrato'],
                parms: {
                    where: {
                        id_operadora: this.id_operadora,
                    },
                    cad_operadora: true,
                },
                final: () => {
                    this.contador_guias_contrato = !!this.$store.state.contexto['gerar-numero-guia-por-contrato'];
                }
            })
        }
    },

    created () {
        this.$store.commit('loading', true);
    },

    mounted () {
        this.load ();
    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },

}
</script>